import { ColumnDef } from '@tanstack/react-table';
import { BrandAndProduct } from '@toggle/toggle';
import { TFunction } from 'i18next';
import React from 'react';

import { TopRankIcon } from '../../../top-rank-icon/TopRankIcon';
import * as S from '../BrandsAndProductsTable.styles';

export const RANK_COLUMN_ID = 'rank';
const PRODUCT_BRAND_COLUMN_ID = 'productBrand';
const DESCRIPTION_COLUMN_ID = 'description';

export const getColumns = ({
  t,
}: {
  t: TFunction;
}): ColumnDef<BrandAndProduct>[] => [
  {
    id: RANK_COLUMN_ID,
    header: t('widget:assetOverview.knowledgeGraph.brandsAndProducts.rank'),
    cell: props => {
      const { original } = props.row;
      return (
        <S.RankWrapper>
          <TopRankIcon rank={original.relationship.rank} />
        </S.RankWrapper>
      );
    },
  },
  {
    id: PRODUCT_BRAND_COLUMN_ID,
    header: t(
      'widget:assetOverview.knowledgeGraph.brandsAndProducts.productBrand'
    ),
    cell: props => (
      <S.ProductWrapper>{props.row.original.product}</S.ProductWrapper>
    ),
  },
  {
    id: DESCRIPTION_COLUMN_ID,
    header: t(
      'widget:assetOverview.knowledgeGraph.brandsAndProducts.description'
    ),
    cell: props => {
      return (
        <S.DescriptionWrapper>
          {props.row.original.relationship.description}
        </S.DescriptionWrapper>
      );
    },
  },
];
